module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/awesome-typescript-loader/dist/entry.js?silent=true!./job-info-popup.ts"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy!./ClientApp/components/job-info-popup/job-info-popup.ts
// module id = 103
// module chunks = 53